import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20background%20with%20soft%20gradients%20romantic%20atmosphere%20beige%20and%20warm%20rose%20tones%20minimalist%20artistic%20style%20gentle%20bokeh%20effect%20high%20detail%20sophisticated%20texture&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-foreground-950/50"></div>
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">
          准备好开始你的约炮之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-6 md:mb-8 leading-relaxed">
          从心态准备到实战技巧，从平台选择到安全指南，约炮攻略为你提供全方位的指导。现在就行动起来，开启愉快的约会体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/yuepao-jiqiao"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line"></i>
            开始学习约炮技巧
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}